import React, { useEffect, useState } from 'react';
import { Play, Pause } from 'lucide-react';
import { artistInfo } from '../data/mock';

const Hero = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-black">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <img
          src={artistInfo.heroBackground}
          alt="Studio Background"
          className="w-full h-full object-cover opacity-40"
          onError={(e) => { e.target.src = "https://images.unsplash.com/photo-1598488035139-bdbb2231ce04?w=1920&q=80"; }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black"></div>
      </div>

      {/* Content */}
      <div
        className={`relative z-10 text-center px-4 max-w-5xl mx-auto transition-all duration-1000 transform ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}
      >
        <h1 className="font-display text-4xl sm:text-5xl md:text-7xl lg:text-8xl xl:text-9xl font-bold uppercase tracking-wider text-white mb-4 sm:mb-6 px-2">
          {artistInfo.name}
        </h1>
        <p className="text-lg sm:text-xl md:text-2xl lg:text-3xl text-gray-300 mb-3 sm:mb-4 tracking-wide px-4">
          {artistInfo.tagline}
        </p>
        <p className="text-sm sm:text-base md:text-lg text-gray-400 max-w-2xl mx-auto mb-8 sm:mb-12 px-6">
          {artistInfo.bio}
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center items-center px-4">
          <button
            onClick={() => scrollToSection('beats')}
            className="group w-full sm:w-auto px-6 sm:px-8 py-3 sm:py-4 bg-gradient-to-r from-rose-800 to-violet-800 text-white rounded-full font-semibold uppercase text-xs sm:text-sm tracking-wider hover:scale-105 transition-all duration-300 shadow-lg hover:shadow-rose-500/50 flex items-center justify-center gap-2"
          >
            <Play size={18} className="group-hover:scale-110 transition-transform" />
            Écouter mes Beats
          </button>
          <button
            onClick={() => scrollToSection('services')}
            className="w-full sm:w-auto px-6 sm:px-8 py-3 sm:py-4 border-2 border-white text-white rounded-full font-semibold uppercase text-xs sm:text-sm tracking-wider hover:bg-white hover:text-black transition-all duration-300"
          >
            Travailler Ensemble
          </button>
        </div>

        {/* Scroll Indicator */}
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
          <div className="w-6 h-10 border-2 border-white/30 rounded-full flex justify-center">
            <div className="w-1 h-3 bg-white/50 rounded-full mt-2 animate-pulse"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;